<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="tips">
          <el-page-header @back="goBack" content="徒弟日志"></el-page-header>
        </div>
      </div>
      <div class="search">
        <el-input
          v-model="query.keyword"
          placeholder="请输入搜索关键字"
          suffix-icon="el-icon-search"
          @change="
            query.pageIndex = 1;
            initData();
          "
        >
        </el-input>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th>序</th>
            <th style="width:20%;" class="left">标题</th>
            <th style="width:53%;" class="left">内容</th>
            <th style="width:10%;">日期</th>
            <th style="width:10%;">师傅评论</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="10">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>
          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ item.row }}</td>
            <td class="left">
              <router-link
                to=""
                @click.native="
                  dialogLogDetailsVisible = true;
                  getLogDetails(item.id);
                "
              >
                {{ item.title }}
              </router-link>
            </td>
            <td class="left" v-html="item.content"></td>
            <td>
              {{ item.create_time.substr(0, 10) }}
            </td>
            <td>
              <span v-if="item.is_evaluation > 0">✔️</span>
              <span v-else>
                <span v-if="!item.is_expired">
                  <router-link to="">
                    <el-tooltip content="评论" placement="top">
                      <i
                        class="el-icon-edit-outline"
                        @click="
                          dialogLogVisible = true;
                          getLogDetails(item.id);
                        "
                      ></i>
                    </el-tooltip>
                  </router-link>
                </span>
                <span v-else>--</span>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="日志详情"
      :visible.sync="dialogLogDetailsVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item
          label="日期"
          prop="create_time"
          :label-width="formLabelWidth"
        >
          <span>{{ form.create_time }}</span>
        </el-form-item>
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <span v-html="form.title"></span>
        </el-form-item>
        <el-form-item label="内容" prop="content" :label-width="formLabelWidth">
          <span v-html="form.content"></span>
        </el-form-item>
        <el-form-item
          label="评论内容"
          prop="content"
          :label-width="formLabelWidth"
          v-if="form.is_evaluation > 0"
        >
          <span v-html="form.evaluation_content"></span>
        </el-form-item>

        <el-form-item
          label="评论人"
          prop="evaluation_user_name"
          :label-width="formLabelWidth"
          v-if="form.is_evaluation > 0"
        >
          <span
            v-html="`${form.evaluation_user_name} · ${form.evaluation_time}`"
          ></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click.native="dialogLogDetailsVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="日志"
      :visible.sync="dialogLogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item
          label="日期"
          prop="create_time"
          :label-width="formLabelWidth"
        >
          <span>{{ form.create_time }}</span>
        </el-form-item>
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <span v-html="form.title"></span>
        </el-form-item>
        <el-form-item label="内容" prop="content" :label-width="formLabelWidth">
          <span v-html="form.content"></span>
        </el-form-item>
        <el-form-item
          label="评论内容"
          prop="evaluation_content"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="form.evaluation_content"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancle">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MasterLog',
  data() {
    return {
      model: {},
      query: {
        apprenticeId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 20,
        keyword: undefined,
      },
      list: [],
      dialogLogDetailsVisible: false,
      dialogLogVisible: false,
      form: {
        id: 0,
        title: '',
        content: '',
        create_time: '',
        evaluation_content: '',
        evaluation_user_name: '',
        evaluation_time: '',
      },
      rules: {
        evaluation_content: [
          { required: true, message: '请输入评价内容', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituLogs();
    },
    // 获取日志列表
    async getShituLogs() {
      const response = await this.$api.shitu.getShituLogs(this.query);
      this.list = response.data.data;
    },
    // 返回上一层
    goBack() {
      this.$router.go(-1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },

    // ------------------日志-Begin------------------
    // 获取日志详情
    async getLogDetails(logId) {
      const response = await this.$api.shitu.getLogDetails({
        id: logId,
      });
      this.form = response.data.data;
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        id: this.form.id,
        evaluation_content: this.form.evaluation_content,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          console.log(submitData);
          this.editLogEvaluation(submitData);
        }
      });
    },
    async editLogEvaluation(evaluation) {
      const response = await this.$api.shitu.editLogEvaluation(evaluation);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogLogVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    handleCancle() {
      this.dialogLogVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    // ------------------日志-End------------------
  },
};
</script>
